import { cn } from "@/lib/utils"

interface OfferHeroProps {
  title: string
  subtitle: string
  bg: string
  /**
   * Optional centered glyph. When set, `bg` is a cosmic backdrop (flipped, as in
   * the design) with the glyph on top. When omitted, `bg` is the full
   * illustration and is shown as-is.
   */
  sign?: string
  /** When true (default) the image bleeds to the full 414px width. */
  fullBleed?: boolean
}

/** Hero: centered title/subtitle + an illustration (full-bleed or column-width). */
export function OfferHero({ title, subtitle, bg, sign, fullBleed = true }: OfferHeroProps) {
  return (
    <div data-slot="offer-hero" className="flex flex-col items-center">
      <div className="flex flex-col items-center gap-2 text-center">
        <h2 className="font-display text-2xl font-medium text-purple-light">{title}</h2>
        <p className="text-base leading-snug text-purple-light/70">{subtitle}</p>
      </div>

      {/* Full-bleed cancels the column's px-4 so the image spans the full 414px */}
      <div
        className={cn(
          "relative h-[290px] overflow-hidden",
          fullBleed ? "-mx-4 w-[calc(100%+2rem)]" : "w-full",
        )}
      >
        <img
          src={bg}
          alt=""
          aria-hidden
          className={cn("absolute inset-0 size-full object-cover", sign && "-scale-y-100")}
        />
        {sign && (
          <img src={sign} alt="" className="absolute left-1/2 top-20 size-[120px] -translate-x-1/2" />
        )}
      </div>
    </div>
  )
}
